<div class="app-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="app-toolbar">
    <div class="app-toolbar-sections">
      <!-- Start: Hamburger + Title -->
      <div class="app-toolbar-start">
        <button mat-icon-button (click)="mainSideNav.toggle()"><mat-icon>menu</mat-icon></button>
        <span class="app-toolbar-title" i18n="@@Account Settings">Account Settings</span>
      </div>

      <!-- End -->
      <div class="app-toolbar-end">
        <app-shopping-cart-top-bar-button></app-shopping-cart-top-bar-button>
        <app-active-role></app-active-role>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container class="app-sidenav-container" (backdropClick)="mainSideNav.close()" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav opened #mainSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" (keydown.escape)="mainSideNav.close()" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list>
        <app-side-nav focus="settings"></app-side-nav>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="m2app-dark">
      <div class="app-content">
        <app-organization *ngIf="organization" [organization]="organization" [allowAdminRescue]="false"></app-organization>
        <app-sales-tax-exemption-organization-panel
            *ngIf="organization && startupService.selectedRole === 'organization'"
            [organization]="organization">
        </app-sales-tax-exemption-organization-panel>

        <!-- Checkout convenience surfaces.
             These let the user manage the same data that the cart/checkout
             accordion manages (address book, saved credit cards) without
             having to put items in the cart and pretend to check out.
             The default carrier / service level is managed inside the
             <app-organization> "Preferred Shipping" panel above. -->
        <mat-card *ngIf="organization && startupService.selectedRole === 'organization'" appearance="outlined" class="settings-card">
          <mat-card-header>
            <mat-card-title i18n="@@Checkout Defaults">Checkout Defaults</mat-card-title>
            <mat-card-subtitle i18n="@@CheckoutDefaultsDescription">Manage the addresses, credit cards, and shipping preferences that are offered to you at checkout. You can also manage these from inside the shopping cart.</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <mat-accordion multi="true" displayMode="flat">
              <app-address-book></app-address-book>
              <app-saved-payment-methods></app-saved-payment-methods>
            </mat-accordion>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
